export default __webpack_public_path__ + "media/icons/check-circle-solid-fe83839f.svg";